import styled from "styled-components"
import {
  tabletTextStyles,
  mobileTextStyles,
  desktopTextStyles,
} from "./typography.styles"
import Breakpoints from "./breakpoints"

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: auto;
  padding: 0 20px;
  ::after {
    content: "";
    width: 75vw;
    margin: 0 auto;
    height: 64px;
    border-bottom: 1px solid var(--dark-mode-heading);
  }

  @media (min-width: ${Breakpoints.md}) {
    padding: 0px 0px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-template-columns: 42vw 8vw 50vw;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
    ::after {
      display: none;
    }
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: -3 / -1;
    grid-row: 1;
  }
`

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    grid-column: 1 / 3;
    grid-row: 1;
    padding: 96px 16.5%;
    z-index: 10;
    background: #282828;
    mix-blend-mode: multiply;
  }
`

export const MainText = styled.h3`
  text-align: center;

  ${mobileTextStyles.MobileHeadingTwoRegular}
  color: var(--slate);

  margin: 32px 0 48px 0;

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoRegular}
    margin: 24px 0 32px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeRegular}
    text-align: left;
    color: var(--dark-mode-body-grey);
    margin: 0 0 48px 0;
  }
`
